import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IRangeOfMotionBehavior } from "../../../../documaker/domain/format/objects";

export interface IRangeOfMotionBehaviorPropertyEditable {
  rangeOfMotionBehavior(): IPropertyEditable<IRangeOfMotionBehavior>;
}

export function instanceOfIRangeOfMotionBehaviorPropertyEditable(instance: any): instance is IRangeOfMotionBehaviorPropertyEditable {
  return instance
      && instance.rangeOfMotionBehavior
      && instanceOfIPropertyEditable<IRangeOfMotionBehavior>(instance.rangeOfMotionBehavior());
}
